//#region Old Code

// import React from "react";
// import { TENANTS } from "../../consts/tables";
// import TenantInfo from "./TenantInfo";
// import CRUD from "../CRUD/CRUD";
// import { browserHistory } from "react-router";
// import { getData, manageData } from "../../requests/CRUD";

// export default class CRUDTenant extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       data: null,
//       original: null,
//       isBusy: null,
//       error: null,
//       success: null,
//       errorTabs: [],
//       currentTab: 0,
//       viewMode: this.props.edit || false,
//     };

//     this.handleSubmit = this.handleSubmit.bind(this);
//     this.handleChangeInput = this.handleChangeInput.bind(this);
//     this.saveData = this.saveData.bind(this);
//   }

//   componentWillReceiveProps(nextProps) {
//     if (this.props.params.id !== nextProps.params.id) {
//       this.fetch(nextProps.params.id);
//     }
//   }

//   componentDidMount() {
//     this.fetch(this.props.params.id);
//   }

//   fetch(id) {
//     this.setState({
//       data: null,
//       error: null,
//       success: null,
//     });

//     if (id === undefined) {
//       this.setState({
//         data: {},
//       });
//       return;
//     }

//     getData({
//       tableCode: TENANTS,
//       options: {
//         filter: [
//           {
//             text: id,
//             code: "ARCIMEDES_ROW_ID",
//             type: "exact",
//           },
//         ],
//       },
//     }).then((res) => {
//       if (res && res.success && Array.isArray(res.data) && res.data.length) {
//         this.setState({
//           data: res.data[0],
//           original: { ...res.data[0] },
//           error: null,
//         });
//       } else {
//         this.setState({
//           data: false,
//           error: res.message ? res.message : "Unidentified Error",
//         });
//       }
//     });
//   }

//   handleSubmit(e) {
//     e.preventDefault();

//     if (this.state.viewMode) this.setState({ viewMode: false });

//     if (
//       this.state.isBusy ||
//       this.state.data.NAME === "" ||
//       this.state.viewMode === true
//     )
//       return;

//     this.setState({ viewMode: true }, () => this.saveData());
//   }

//   handleChangeInput(key, value) {
//     this.setState({
//       data: Object.assign(this.state.data, {
//         [key]: value,
//       }),
//     });
//   }

//   saveData() {
//     if (this.state.isBusy) return;

//     this.setState({
//       isBusy: true,
//       error: null,
//       success: null,
//     });

//     return manageData({ tableCode: TENANTS, data: [this.state.data] }).then(
//       (res) => {
//         if (res && res.success) {
//           this.setState(
//             {
//               isBusy: false,
//               success: "Saved",
//             },
//             () => {
//               if (!this.props.edit) {
//                 browserHistory.push({
//                   pathname: `/tenant/${res.data[0].ARCIMEDES_ROW_ID}`,
//                 });
//               }
//             }
//           );
//           window.scrollTo(0, 0);
//         } else {
//           this.setState({
//             isBusy: null,
//             error: res && res.message ? res.message : "Unspecified error",
//           });
//         }
//       }
//     );
//   }

//   render() {
//     const data = this.state.data;
//     const { edit, isSuper } = this.props;

//     return (
//       <CRUD
//         tabsData={[
//           {
//             name: "TENANT",
//             renderedComponent: (
//               <TenantInfo
//                 data={data}
//                 handleChangeInput={this.handleChangeInput}
//                 viewMode={this.state.viewMode}
//                 deleted={data && data.DELETED === "1"}
//               />
//             ),
//           },
//         ]}
//         backLink={`${arc.path.base}tenants`}
//         edit={edit}
//         state={this.state}
//         setState={this.setState.bind(this)}
//         handleSubmit={this.handleSubmit}
//         saveData={this.saveData}
//         type="tenant"
//         backName="TENANTS"
//         title={data && `${data.NAME}`}
//         isSuper = {isSuper}
//       />
//     );
//   }
// }

//#endregion

import React,{createRef } from "react";
import { TENANTS } from "../../consts/tables";
import TenantInfo from "./TenantInfo";
import CRUD from "../CRUD/CRUD";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import { ApolloConsumer } from "@apollo/client";
import { GET_TENANTS, GET_TENANT_BY_ID } from "../Graphql/Queries/TenantQuery";
import { CREATE_TENANTS } from "../Graphql/Mutations/TenantMutation";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_CONTACTS_TENANTS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_CONTACT_TENANTS_BY_ID, GET_CONTACT_TENANTS_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import NotesReusable from "../NotesReusable";
import { sanitizeNotesForInput } from "../../utils";

export default class CRUDTenant extends React.Component { 
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      searchCrudFilter : false,
      filterData: [],
      currentIndex: 0,
      fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
      isExists: false,
      typeDuplicate:null
    };
    this.client = null;
    this.notesRef = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.updateURL = this.updateURL.bind(this);
    this.handleNotesChange = this.handleNotesChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    if (this.state.fromListUrl) {
      localStorage.setItem('fromListUrl', this.state.fromListUrl);
      this.setState({ fromListUrl: this.state.fromListUrl });
    }
    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    if(!hasQuery){
      this.fetch(this.props.params.id);
    }
    if(hasQuery){
      this.setState({ searchCrudFilter: true });
      this.handleQueryChange();
    }
  }

  parseFilterOptions(query){
    const filterObject = {};
    if(query){
        for(const key in query){
            if(key !== 'order' && key !== 'page'){
                filterObject[key]= query[key]
            }
        }
    }
    return [filterObject]
}

 componentDidUpdate(prevProps) {

    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
    if (hasQuery && prevProps.location.search !== this.props.location.search) {
      this.handleQueryChange();
      this.setState({ searchCrudFilter: true });
    }
    // Check if the query has changed
    // if (prevProps.location.search !== this.props.location.search) {
    //   this.handleQueryChange();
    // }
    if(!hasQuery && prevHasQuery){
      this.fetch(this.props.params.id);
      this.setState({ searchCrudFilter: false });
    }
  }

handleNotesChange(updatedNotes, editId) {
  const cleanedNotes = updatedNotes
    .filter((note) => note.text && note.text.trim() !== "")
    .filter((note) => {
      // Case 1: new note (no arcimedes_row_id)
      if (!note.arcimedes_row_id) return true;

      // Case 2: edited note (arcimedes_row_id matches editId)
      if (editId && note.arcimedes_row_id === editId) return true;

      // Case 3: deleted note
      if (note.deleted === 1) return true;

      // Skip everything else
      return false;
    })
    .map(
      ({
        __typename,
        arcimedes_created,
        arcimedes_modified,
        arcimedes_created_by,
        arcimedes_modified_by,
        temp_id,
         date,
        ...rest
      }) => rest
    );

  this.setState((prev) => ({
    data: {
      ...prev.data,
      notes: cleanedNotes,
    },
  }));
}

  handleQueryChange() {
    const query = this.props.location.query;
    const filterOptions = this.parseFilterOptions(query); 
  
    var isNoFilter = Object.keys(filterOptions).length === 0; 
  
    if (isNoFilter) {
      this.fetch(this.props.params.id);
    }
    else{
      this.fetchWithFilter(filterOptions)
    }
  }

fetchWithFilter(filterOptions) {
  this.setState({
    data: null,
    error: null,
    success: null,
  });

  fetchData(GET_CONTACT_TENANTS_LIST_QUERY, { type:"Tenant",filters:filterOptions})
        .then(res => {
          const filterData = res.data.getContacts.data|| [];
          if(filterData.length > 0){
            this.setState({
              // items: res.data.getCompanies.data,
              // totalCount: res.data.getCompanies.totalCount,
              // error: null,
              // isBusy: null,
              filterData,
              currentIndex:0,
              data:  filterData[0],
              original: { ...filterData[0] },
              error: null,
            },() => {
              this.updateURL(filterData[0]);
            });
          }else {
            this.setState({
              filterData: [],
              data: false,
              error: "No filtered data found. Please try again with different filters.",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
    
}



updateURL(data) {
    const queryParams = new URLSearchParams(this.props.location.search);
    // const name = queryParams.get("name");
    // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
    const newUrl = `/Tenant/${data.contact_id}?${queryParams.toString()}`;
    browserHistory.push(newUrl);
  }

  fetch(id) {
    this.setState({
    // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader 
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({
        data: { contact_type: ["Tenant"] },
      });
      return;
    }
    const token = localStorage.getItem('authToken');

    // this.client
    //     .query({
    //       query: GET_TENANT_BY_ID,
    //       variables: { arcimedes_row_id: id },
    //       fetchPolicy: "no-cache",
    //       context: {
    //         headers: {
    //           authorization: `Bearer ${token}`,
    //         },
    //       },
    //     })
    // fetchData(GET_TENANT_BY_ID, { arcimedes_row_id: id })
    // .then((res) => {
    //   if (res && res.data && res.data.getTenent) {
    //     this.setState({
    //       data: res.data.getTenent,
    //       original: { ...res.data.getTenent },
    //       error: null,
    //     });
    fetchData(GET_CONTACT_TENANTS_BY_ID, { contactid: Number(id) })
        .then((res) => {
          if (res && res.data && res.data.getContactByContactid) {
            this.setState({
              data: res.data.getContactByContactid.contact,
              original: { ...res.data.getContactByContactid.contact},
              error: null,
            });
          } else {
            this.setState({
              data: false,
              error: res.errors ? res.errors[0].message : "Unidentified Error",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
  }

  handleSubmit(client, e) {
    e.preventDefault();
    this.setState({
      isExists:false,
      typeDuplicate:null
    });
    if (this.state.viewMode) this.setState({ viewMode: false });
if (this.notesRef.current && this.notesRef.current.validateNotes) {
  const isValid = this.notesRef.current.validateNotes();
  if (!isValid){
      console.log("Stop submit: notes invalid");
     return;
  }
}
    if (
      this.state.isBusy ||
      (this.state.data.first_name  === "" || this.state.data.last_name  === "") ||
      this.state.viewMode === true
    )
      return;

    this.setState({ viewMode: true }, () => this.saveData(client));
  }

  handleChangeInput(key, value) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [key]: value
      }
    }));
  }
  
  handleChangeDropdown(query, queryType, x, key) {
    const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());

    if (key === "contact_type" && (userContactTypes.length > 1 || query.contact_type === "Tenant") && this.state.typeDuplicate) {
      const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
      const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

      const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
      if (!hasMatch) {
        this.setState({
          isExists: false,
          typeDuplicate: null,
          isBusy: false,
        });
      }
    }
    this.setState({
        data: Object.assign(this.state.data, {
            [key]: query[key],
        }),
    });
}

 async saveData(client) {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });
const input = {
  //contact_type: "Tenant",
  contact_type: Array.isArray(this.state.data.contact_type)   ? this.state.data.contact_type  : typeof this.state.data.contact_type === "string"  ? this.state.data.contact_type.split(",") : ["Tenant"],
  contact_id : this.props.params.id ? this.props.params.id : "",
  arcimedes_row_id: Number(this.props.params.id),
  //name: this.state.data.name,
  first_name:this.state.data.first_name,
  last_name:this.state.data.last_name,
  deleted: this.state.data.deleted,
  address:this.state.data.address ,
  city:this.state.data.city ,
  state:this.state.data.state ,
  zip: this.state.data.zip,
  //...(this.state.data.contact_type.includes("Lender") && {
    name: this.state.data.contact_type.includes("Lender") ? this.state.data.name : "",
    notes: sanitizeNotesForInput(this.state.data && this.state.data.notes),
 // }),
  //...(this.state.data.contact_type.includes("Team") && {
    cell_phone: this.state.data.contact_type.includes("Team") ? this.state.data.cell_phone : null,
    email: this.state.data.contact_type.includes("Team") ? this.state.data.email : null,
  //})
};
    try {
      // const token = localStorage.getItem('authToken');
      // const variables= {    
      //   arcimedes_row_id: this.props.params.id, 
      //   name: this.state.data.name,
      //   deleted: this.state.data.deleted}
      const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_TENANTS, {
        input:input
        },)
      // await client.mutate({
      //   mutation: CREATE_TENANTS,
      //   variables: {
      //     arcimedes_row_id: this.props.params.id, 
      //     name: this.state.data.name,
      //     deleted: this.state.data.deleted
      //   },
      //   fetchPolicy: "no-cache",
      //   context: {
      //     headers: {
      //       authorization: `Bearer ${token}`,
      //     },
      //   },
      // });

      if (res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.success) {
        this.setState({
          data:{...input},
          isBusy: false,
          success: "Saved",
        }, () => {
          if (!this.props.edit) {
            browserHistory.push({
              // pathname: `/tenant/${res.data.createOrUpdateTenent.tenent.arcimedes_row_id}`,
              pathname: `/tenant/${res.data.createOrUpdateContact.contact.contact_id}`,
            });
          }
        });

        window.scrollTo(0, 0);
      }
      else if(res && res.data && res.data.createOrUpdateContact && res.data.createOrUpdateContact.error && res.data.createOrUpdateContact.error.includes("already exists")){
        this.setState({
        isExists:true,
        typeDuplicate: res.data.createOrUpdateContact.error,
        viewMode:false
      })
      }
      else{
        this.setState({
          isBusy: null,
          error: res && res.createOrUpdateContact.error ? res.createOrUpdateContact.error : "Unspecified error",
      });
      }
    } catch (error) {
      console.error("Error in saveData:", error);
      this.setState({
        isBusy: false,
        error: error.message || "Unspecified error",
      });
    }
  }

  render() {
    const data = this.state.data;
    const { edit, isSuper } = this.props;

    return (
      <ApolloConsumer>
        {client => {
          if (!this.client) this.client = client;
          return (
            <CRUD
              tabsData={[
                {
                  name: "TENANT",
                  renderedComponent: (
                    <TenantInfo
                      isExists={this.state.isExists}
                      typeDuplicate={this.state.typeDuplicate}
                      data={data}
                      handleChangeInput={this.handleChangeInput}
                      viewMode={this.state.viewMode}
                      deleted={data && data.deleted === 1}
                      handleChangeDropdown={this.handleChangeDropdown}
                      handleParentDropdownChange={this.handleChangeDropdown}
                    />
                  ),
                },
                data &&
                  data.contact_type &&
                  (Array.isArray(data.contact_type)
                    ? data.contact_type.some((type) =>
                        type
                          .split(",")
                          .some((t) =>
                            ["Agent","Lender", "Vendor", "Investor"].includes(t.trim())
                          )
                      )
                    : data.contact_type
                        .split(",")
                        .some((t) =>
                          ["Agent","Lender", "Vendor", "Investor"].includes(t.trim())
                        )) && {
                    name: "NOTES",
                    renderedComponent: (
                     <NotesReusable
                     data={data}
                      notes={data && data.notes ? data.notes : []}
                      contact_id = {data && data.contact_id ? data.contact_id : null}
                      viewMode={this.state.viewMode}
                      handleChangeInput={this.handleChangeInput}
                       ref={this.notesRef}
                      //deleted={data && data.DELETED === "1"}
                      deleted={data && data.deleted === "1"}
                      setState={this.setState.bind(this)}
                      onNotesChange={this.handleNotesChange}
                      state={this.state}
                      /> 
                    ),
                  },
              ]}
              backLink={`${arc.path.base}contacts/tenants`}
              edit={edit}
              state={this.state}
              setState={this.setState.bind(this)}
              handleSubmit={(e) => this.handleSubmit(client, e)}
              saveData={() => this.saveData(client)}
              type="tenant"
              backName="TENANTS"
              title={data && `${data.first_name} ${data.last_name}`}
              isSuper={isSuper}
              filterData={this.state.filterData}
              currentIndex={this.state.currentIndex}
              updateURL={this.updateURL}
              // backToUrl={"tenants"}
              backToUrl={
                this.state.fromListUrl ? this.state.fromListUrl : "/tenants"
              }
            />
          );
        }}
      </ApolloConsumer>

    );
  }
}
